<div class="col-6 row">
  <div class="col-4 details-key-main">
    <div class="col-12">
      {{field.label}}
    </div>
  </div>
  <div class="col-8">
    <div class="form-group col-12 paddingzero margin-bottom-0 row">
      <div class="col-12">
        <div class="col-12" style="margin: 10px 0px 10px 0;" [formGroup]="group">
          <mat-radio-group [formControlName]="field.name">
            <mat-radio-button *ngFor="let item of field.options" [value]="item">{{item}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
</div>
